$ = require('jquery')

GroupEditCtrl = ($scope ,$location ,$filter ,flash ,formDialogService ,formFileReaderService ,groupDataService ,groupRegisDataService , groupInfo ,groupStatus ,userInfo ,$ngConfirm) ->
  # check is admin
  if groupStatus.role != 'admin'
    return $location.path('/groups')

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
  )
  angular.element(document.body).css 'min-width', 0
  $scope.isSubmitting = false
  $scope.policyDatas = groupDataService.getPolicyData()
  maxFileUploadSize = 5000000
  $scope.group = groupInfo
  $scope.group.type = if groupInfo.public_status then '1' else '0'
  $scope.croppedCoverPhoto = groupInfo.cover_url
  $scope.croppedAvatarPhoto = groupInfo.avatar_url

  defDirS3 = {
    prefixCover: 'images/group/cover/'
    prefixAvatar: 'images/group/avatar/'
  }

  # cover url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then (resp) ->
    $scope.preDataCover = resp.data
  # avatar url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixAvatar).then (resp) ->
    $scope.preDataAvatar = resp.data

  $scope.choosePolicy = (policy) ->
    $scope.group.type = policy

  $scope.chooseCover = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('coverPhoto', file).then (data) ->
        $scope.coverData = data
        $scope.coverPhoto = data.base64Data
        $('.crop-image-modal').modal 'show'
    )

  $scope.chooseAvatar = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('avatar', file).then (data) ->
        $scope.avatarData = data
        $scope.avatarPhoto = data.base64Data
        $('.crop-icon-modal').modal 'show'
    )

  $scope.cancelCropModal = ->
    $scope.coverPhoto = ''
    $('#coverPhoto').attr('src', '')
    $scope.croppedCoverPhoto = $scope.group.cover_url
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submitCropModal = ->
    $('.crop-image-modal').modal 'hide'
    return

  $scope.cancelCropIconModal = ->
    $scope.avatarPhoto = ''
    $('#avatar').attr('src', '')
    $scope.croppedAvatarPhoto = $scope.group.avatar_url
    $('.crop-icon-modal').modal 'hide'
    return

  $scope.submitCropIconModal = ->
    $('.crop-icon-modal').modal 'hide'
    return

  $scope.btnCancelClick = ->
    $location.path('/groups')

  $scope.submit = (group) ->
    $scope.isSubmitting = true

    coverFile = if $scope.coverPhoto?
      $scope.croppedCoverPhotoBlob
    else
      $scope.croppedCoverPhoto

    avatarFile = if $scope.avatarPhoto?
      $scope.croppedAvatarPhotoBlob
    else
      $scope.croppedAvatarPhoto

    coverData = {
      coverFile: coverFile
      url: $scope.preDataCover.url
      fields: $scope.preDataCover.fields
    }

    avatarData = {
      coverFile: avatarFile
      url: $scope.preDataAvatar.url
      fields: $scope.preDataAvatar.fields
    }
    groupRegisDataService.updateGroup($scope.group , coverData , avatarData)
      .then (data) ->
        if data == 'success'
          flash.success data
          $scope.isSubmitting = false
          $location.path('/groups')
      , (data) ->
        flash.error $filter('translate')('API_ERROR')
        $scope.isSubmitting = false

  isNotValidSizeFile = (file) ->
    file.size > maxFileUploadSize

  openFileDialog = (callback) ->
    options = {
      accept : 'image/*'
    }
    formDialogService._open(options , (file,fileLocation) ->
      if isNotValidSizeFile(file)
        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes')
        return
      callback(file,fileLocation)
    )

GroupEditCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'flash'
  'formDialogService'
  'formFileReaderService'
  'groupDataService'
  'groupRegisDataService'
  'groupInfo'
  'groupStatus'
  'userInfo'
  '$ngConfirm'
]

module.exports = GroupEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-edit-controller.coffee